import { getMcpEnvironment } from '@app/access/utils';
import { useNewUserAccessRights } from '@app/hooks/useNewUserAccessRights';
import { useUserPrint } from '@app/hooks/useUserPrint';

export const useMcpAccess = () => {
  const { userId, isAuth } = useUserPrint();
  const { userAccessRights } = useNewUserAccessRights();
  const environment = getMcpEnvironment();

  return {
    environment,
    allowed:
      isAuth &&
      environment !== null &&
      userAccessRights.UserId === userId &&
      (userAccessRights.IsAdmin === true ||
        userAccessRights.IsSuperAdmin === true),
  };
};
